import React from "react";
import { useParams } from "react-router-dom";
import AuditLogViewer from "./AuditLogViewer";

const OrganizationAuditPage = () => {
  const { organizationId } = useParams();

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Audit Log</h1>
        <p className="text-muted-foreground">
          View audit trail and activity logs for this organization
        </p>
      </div>
      <AuditLogViewer organizationId={organizationId} />
    </div>
  );
};

export default OrganizationAuditPage;
